
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import BrandsSection from './components/BrandsSection';
import MarketInsightsSection from './components/MarketInsightsSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <BrandsSection />
        <MarketInsightsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
